import * as activityLogTypes from './activityLogType'
import * as activityLogs from './activityLog'
import * as aiLineage from './aiLineage'
import * as assetCommentTypes from './assetCommentType'
import * as assetComments from './assetComment'
import * as assetTypes from './assetType'
import * as assets from './asset'
import * as blockedServiceJobs from './blockedServiceJob'
import * as blockouts from './blockout'
import * as capacities from './capacity'
import * as clientResources from './clientResource'
import * as clientYoutubeChannels from './clientYoutubeChannel'
import * as clients from './client'
import * as clientsV4 from './clientV4'
import * as clientFlagsV4 from './clientFlagV4'
import * as containerSas from './containerSas'
import * as ctClientResources from './ctClientResource'
import * as currentUser from './currentUser'
import * as currentUserV4 from './currentUserV4'
import * as emailReplacements from './emailReplacement'
import * as emailRequests from './emailRequest'
import * as employmentTypesV4 from './employmentTypeV4'
import * as entities from '../entities'
import * as fileServiceContainers from './fileServiceContainer'
import * as filters from './filter'
import * as navigation from './navigation'
import * as notificationTypes from './notificationType'
import * as notifications from './notification'
import * as prompts from './prompt'
import * as providerFlagsV4 from './providerFlagV4'
import * as providersV4 from './providerV4'
import * as resourceTypes from './resourceType'
import * as resources from './resource'
import * as serviceCategories from './serviceCategory'
import * as serviceGroups from './serviceGroup'
import * as serviceJobChecklistItems from './serviceJobChecklistItem'
import * as serviceJobChecklistItemTypes from './serviceJobChecklistItemType'
import * as serviceJobClientDetails from './serviceJobClientDetail'
import * as serviceJobDetails from './serviceJobDetail'
import * as serviceJobFilter from './serviceJobFilter'
import * as serviceJobHistories from './serviceJobHistory'
import * as serviceJobNotes from './serviceJobNote'
import * as serviceJobPushRaw from './serviceJobPushRaw'
import * as serviceJobSendToEsoft from './serviceJobSendToEsoft'
import * as serviceJobSetAvailable from './serviceJobSetAvailable'
import * as serviceJobStatuses from './serviceJobStatus'
import * as serviceJobTags from './serviceJobTag'
import * as serviceJobUserRoles from './serviceJobUserRole'
import * as serviceJobUsers from './serviceJobUser'
import * as serviceJobs from './serviceJob'
import * as serviceJobsSearch from './serviceJobSearch'
import * as serviceJobsTimeTrackers from './serviceJobTimetracker'
import * as serviceTypesV4 from './serviceTypeV4'
import * as slots from './slot'
import * as statesV4 from './stateV4'
import * as statistics from './statistic'
import * as timetrackers from './timetracker'
import * as userFlagsV4 from './userFlagV4'
import * as userRoles from './userRole'
import * as userRolesV4 from './userRoleV4'
import * as userTimes from './userTime'
import * as users from './user'
import * as usersV4 from './userV4'
import * as vsirStatuses from './vsirStatus'
import * as wordReplacements from './wordReplacement'
import * as workflows from './workflow'
import * as youtubeChannels from './youtubeChannel'
import * as zoneFlagsV4 from './zoneFlagV4'
import * as zones from './zone'
import * as zonesV4 from './zoneV4'

const modules = {
  activityLogTypes,
  activityLogs,
  aiLineage,
  assetCommentTypes,
  assetComments,
  assetTypes,
  assets,
  blockedServiceJobs,
  blockouts,
  capacities,
  clientResources,
  clientYoutubeChannels,
  clients,
  clientsV4,
  clientFlagsV4,
  containerSas,
  ctClientResources,
  currentUser,
  currentUserV4,
  emailReplacements,
  emailRequests,
  employmentTypesV4,
  entities,
  fileServiceContainers,
  filters,
  navigation,
  notificationTypes,
  notifications,
  prompts,
  providerFlagsV4,
  providersV4,
  resourceTypes,
  resources,
  serviceCategories,
  serviceGroups,
  serviceJobChecklistItems,
  serviceJobChecklistItemTypes,
  serviceJobClientDetails,
  serviceJobDetails,
  serviceJobFilter,
  serviceJobHistories,
  serviceJobNotes,
  serviceJobPushRaw,
  serviceJobSendToEsoft,
  serviceJobSetAvailable,
  serviceJobStatuses,
  serviceJobTags,
  serviceJobUserRoles,
  serviceJobUsers,
  serviceJobs,
  serviceJobsSearch,
  serviceJobsTimeTrackers,
  serviceTypesV4,
  slots,
  statesV4,
  statistics,
  timetrackers,
  userFlagsV4,
  userRoles,
  userRolesV4,
  userTimes,
  users,
  usersV4,
  vsirStatuses,
  wordReplacements,
  workflows,
  youtubeChannels,
  zoneFlagsV4,
  zones,
  zonesV4,
}

export const reducers = Object.keys(modules).reduce((acc, moduleKey) => {
  const module = modules[moduleKey]
  acc[moduleKey] = module.default

  return acc
}, {})

export default modules
